export const updateOperationModalInitValue = {
  data: {
    operationType: '',
    date: '',
    comments: '',
    notaryName: '',
    notaryProtocol: '',
    notaryCity: '',
    hasBeenModified: false,
    hasNotarialRegistration: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal: () => {},
    handleChangeComments(): void {},
    handleChangeNotaryName(): void {},
    handleChangeNotaryProtocol(): void {},
    handleChangeNotaryCity(): void {},
    handleUpdateOperation: () => {},
  },
};
